var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"my-5",attrs:{"width":3,"color":"primary-1","indeterminate":""}})}
var staticRenderFns = []

export { render, staticRenderFns }